import { css } from 'styled-components';
import { standardColours } from '../../styles';

export const boxShadow = () => css`
  box-shadow: 0px 4px 4px 0px ${standardColours.grey};
`;
